import 'components/Owner/Plays/style.css'

import React, { useState, useEffect, useMemo } from 'react'

import { copy, getReturnToPath, isFutureDate, navigateTo } from 'utils/helper'
import {
  PLAY_CARDS,
  PLAY_CARD_BODY_DATA,
  PLAY,
  MEDIA_BUCKET,
  PLAY_TYPE,
  ROLES,
  supportedPlayIds,
  LABEL,
  PathNames,
} from 'config'
import { useAuthentication } from 'utils/authentication'
import { isMobile, isTablet } from 'mobile-device-detect'

import AssessmentQuestion from 'components/Assessment/AssessmentQuestion'
import Button from 'components/Common/Button'
import Collapseable from 'components/Common/Collapseable'
import Loader from 'components/Loaders'
import OptionalPlays from 'components/Owner/Plays/OptionalPlays'
import PlayQuestion from 'components/Owner/Plays/PlayQuestion'
import { PlayScheduleMeetingContainer, PlaysAuthenticationContainer } from 'pages/Owner/container'
import PlayPriceCard from 'components/Owner/Plays/PlayPriceCard'
import PlayStepsPanel from 'components/Owner/Plays/PlayStepsPanel'
import { StepsLargeHeading } from 'components/Owner/Plays/card-style'
import {
  checkIsPlayCompleted,
  isSpecificStepCompleted,
  isValueExist,
} from 'components/Owner/Plays/utils'
import { capitalize, get, isEmpty } from 'lodash'
import { Tool } from '../../../../__generated__/api-types-and-hooks'
import { useFlashParams } from 'hooks/useFlashParams'

const PlayView = ({
  id,
  meta,
  tab,
  tabIndex,
  playData,
  assessmentResponse,
  userId,
  isPlayLoading,
  isConnected,
  oAuthUrl,
  activeTab,
  setupActiveStepIndex,
  playStage,
  changeSetUpStepHandler,
  changeTabHandler,
  updatePlayStageAction,
  toolConnectionSuccessAction,
  saveAssessmentResponseAction,
  getPlayAssessmentResponseAction,
  getAssessmentResponseByQuestionAction,
  getUserConnectorsAction,
  resetOAuthUrlAction,
  handleCyclrOAuthAction,
  uploadFileAction,
  getConnectedPlayAction,
  getUserMeetingAction,
  handleCompletePlayAction,
  isScheduled,
  currentUser,
  savePlayDataAction,
  playValue,
  isPlayCompleted,
  disableButton,
  uploadedFile,
  uploadFileErrors,
  getPlayAction,
  getOAuthUrlAction,
  isPlayDataSaving,
  savePlayResponseAction,
  playResponseData,
  isPlayInReview,
  isToolConnectionSuccessLoading,
}) => {
  const [activeStep, setActiveStep]: any = useState([])
  const [steps, setSteps]: any = useState([])
  const [activeConnectingTool, setActiveConnectingTool] = useState<Tool | null>(null)

  const { flashParams, removeFlashParams } = useFlashParams<{ connectorName: string }>()
  useEffect(() => {
    if (flashParams?.connectorName) {
      toolConnectionSuccessAction({ connectorName: flashParams?.connectorName, playId: id })

      removeFlashParams(['connectorName'])
    } else {
      if (activeConnectingTool?.toolName && !isToolConnectionSuccessLoading) {
        handleCyclrOAuthAction({
          connectorName: activeConnectingTool?.toolName,
          connector: activeConnectingTool?.toolName,
          isPlay: true,
        })
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flashParams?.connectorName, activeConnectingTool])

  useAuthentication(oAuthUrl, getUserConnectorsAction, resetOAuthUrlAction)

  useEffect(() => {
    if (isPlayCompleted && !supportedPlayIds.includes(id)) {
      getAssessmentResponseByQuestionAction({
        question: meta?.questionType,
        type: meta?.assessmentType,
      })
    }
    if (!playStage?.isCompleted && !supportedPlayIds.includes(id)) {
      getPlayAssessmentResponseAction({ play_id: id })
    }

    if (tab?.tabData?.steps.length > 0) {
      let step_data = tab?.tabData?.steps[setupActiveStepIndex]

      setActiveStep(step_data)
      setSteps(tab?.tabData?.steps)
    }
    // setOptions(playStage[tabIndex].steps[setupActiveStepIndex]?.value || [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, setupActiveStepIndex])

  const savePlayData = (playOptionsData) => {
    const foundData = playOptionsData?.options?.filter((option) =>
      playOptionsData?.selectedOption?.includes(option.id)
    )

    const stepData = {
      id: playData.playTabs[tabIndex].tabData.steps[setupActiveStepIndex].stepData[
        playOptionsData?.index
      ].id,
      isCompleted: true,
      label: foundData?.map((data) => data.value),
      value: foundData?.map((data) => data.id),
    }

    const playResponses = {
      playId: id,
      // tabIndex,
      tabId: playData.playTabs[tabIndex].id,
      stepIndex: setupActiveStepIndex,
      stepDataIndex: playOptionsData?.index,
      stepData,
    }

    savePlayResponseAction({ ...playResponses, getResponse: false, isUpdateStage: true })

    if (playData.playTabs.length - 1 !== tabIndex) {
      let nextStepData = playData?.playTabs[tabIndex]?.tabData?.steps[setupActiveStepIndex + 1]
      if (setupActiveStepIndex + 1 < tab?.tabData?.steps.length) {
        changeSetUpStepHandler(nextStepData.id)
      } else {
        changeTabHandler(playData.playTabs[tabIndex + 1].tabName)
      }
    }
  }
  const submitPlayData = (stepDataIndex: number) => {
    if (!isSpecificStepCompleted(playStage, tabIndex, setupActiveStepIndex)) {
      const stepData = {
        id: playData.playTabs[tabIndex].tabData.steps[setupActiveStepIndex].stepData[stepDataIndex]
          .id,
        label:
          playData.playTabs[tabIndex].tabData.steps[setupActiveStepIndex].stepData[stepDataIndex]
            .stepType,
        isCompleted: true,
      }

      let isCompletedPlay = false
      isCompletedPlay = !isEmpty(
        get(
          playResponseData,

          `businessProfileFields.${[
            playData.playTabs[tabIndex].tabData.steps[setupActiveStepIndex].stepData[
              stepDataIndex - 1
            ]?.meta?.businessProfileFields,
          ]}`,
          ''
        )
      )
        ? true
        : false

      const playResponses = {
        redirectToDashboard:
          playData.playTabs.length - 1 === tabIndex &&
          playStage[tabIndex].steps.length === playData.playTabs[tabIndex].tabData.steps.length,
        playId: id,
        tabId: playData.playTabs[tabIndex].id,
        isCompleted: isCompletedPlay,
        tabIndex,
        stepIndex: setupActiveStepIndex,
        stepDataIndex: stepDataIndex,
        stepData,
        getResponse: true,
        submitActivity: playResponseData?.completedAt ? false : true,
        name: playData?.description,
      }
      savePlayResponseAction(playResponses)
    }
    if (playData.playTabs.length - 1 !== tabIndex) {
      let nextStepData = playData?.playTabs[tabIndex]?.tabData?.steps[setupActiveStepIndex + 1]
      if (setupActiveStepIndex + 1 < tab?.tabData?.steps.length) {
        changeSetUpStepHandler(nextStepData.id)
      } else {
        changeTabHandler(playData.playTabs[tabIndex + 1].tabName)
      }
    }
  }
  const moveNext = (stepDataIndex: number) => {
    const tempPlayStage = copy(playStage)

    if (supportedPlayIds.includes(id)) {
      submitPlayData(stepDataIndex)
    } else {
      if (!isSpecificStepCompleted(playStage, tabIndex, setupActiveStepIndex)) {
        const isPlayCompleted: boolean = checkIsPlayCompleted(
          playData,
          tabIndex,
          setupActiveStepIndex
        )
        tempPlayStage[tabIndex].steps[setupActiveStepIndex].isCompleted = true

        let assessmentResponseObj = {
          userId,
          type: id,
          assessmentResponse: {},
          playStage: JSON.stringify(tempPlayStage),
          name: playData?.description,
          submitActivity: assessmentResponse?.completedAt ? false : true,
          isCompleted: isPlayCompleted,
          redirectToDashboard:
            playData.playTabs.length - 1 === tabIndex &&
            playStage[tabIndex].steps.length === playData.playTabs[tabIndex].tabData.steps.length,
        }
        updatePlayStageAction(assessmentResponseObj)
      }

      if (playData.playTabs.length - 1 !== tabIndex) {
        let nextStepData = playData?.playTabs[tabIndex]?.tabData?.steps[setupActiveStepIndex + 1]
        if (setupActiveStepIndex + 1 < tab?.tabData?.steps.length) {
          changeSetUpStepHandler(nextStepData.id)
        } else {
          if (!isSpecificStepCompleted(playStage, tabIndex, setupActiveStepIndex)) {
            getPlayAction({
              playId: id,
              userId: currentUser?.id,
            })
          }
          changeTabHandler(playData.playTabs[tabIndex + 1].tabName)
        }
      }
    }

    window.scrollTo(0, 0)
  }

  function createMarkup(html) {
    return { __html: html.replaceAll('base_url', MEDIA_BUCKET) }
  }

  const checkDisabled = () => {
    if (disableButton) {
      return true
    } else if (playValue) {
      return false
    } else if (
      (playData.playType === PLAY_TYPE.CONNECT || playData.playType === PLAY_TYPE.TOOL) &&
      isConnected
    ) {
      return false
    } else if (playData?.meta?.isDocoSign && !isPlayCompleted) {
      return false
    } else if (playData.playType === PLAY_TYPE.EDUCATION && !isPlayCompleted) {
      return false
    } else if (
      playData.playType !== PLAY_TYPE.EDUCATION &&
      !isPlayCompleted &&
      playData?.playTabs[tabIndex]?.tabData?.steps?.length - 1 === setupActiveStepIndex
    ) {
      return true
    }
    return false
  }

  const isActiveTab = useMemo(() => {
    return activeTab === tab.tabName.toLowerCase()
  }, [activeTab, tab.tabName])

  const tabHasSteps = useMemo(() => {
    const _steps = tab?.tabData?.steps || []
    return _steps.length > 1
  }, [tab?.tabData?.steps])

  const getErrors = (formValue, field) => {
    if (field.label === LABEL.REGISTRATION_MONTH) {
      return isFutureDate(formValue?.month, formValue?.year)
    } else {
      return null
    }
  }

  const { image, pricing } = useMemo(() => tab?.tabData, [tab?.tabData])

  let queryParam = getReturnToPath()
  const redirectPath = queryParam?.returnTo?.toString() || PathNames.Dashboard

  return (
    <>
      {isPlayLoading ? (
        <Loader loader="PlaysLoader" />
      ) : (
        <div id="play-view" className="sm:mx-3 lg:mx-4 mt-10">
          {tab?.tabData?.steps && (
            <div>
              <div className="sm:grid grid-cols-12 gap-8">
                {/* Card */}
                {isActiveTab && tabHasSteps ? (
                  <>
                    {isMobile && isTablet && (
                      <>
                        <div className="col-span-6 mdl:hidden">
                          <PlayStepsPanel
                            steps={steps}
                            currentActiveStep={playStage[tabIndex]}
                            setUpStepId={activeStep?.id}
                            disabled={disableButton}
                            changeSetUpStepHandler={changeSetUpStepHandler}
                          />
                        </div>
                        <div className="col-span-6 mdl:hidden">
                          {pricing ? <PlayPriceCard image={image} price={pricing} /> : null}
                        </div>
                      </>
                    )}
                    {isTablet && (
                      <div id="tablet-only-steps-panel" className="hidden mdl:block mdl:col-span-4">
                        <PlayStepsPanel
                          steps={steps}
                          setUpStepId={activeStep?.id}
                          currentActiveStep={playStage[tabIndex]}
                          disabled={disableButton}
                          changeSetUpStepHandler={changeSetUpStepHandler}
                        />
                        {pricing ? <PlayPriceCard image={image} price={pricing} /> : null}
                      </div>
                    )}
                    {!(isMobile && isTablet) && (
                      <>
                        <div className="lg:col-span-4 hidden lg:block">
                          <PlayStepsPanel
                            steps={steps}
                            setUpStepId={activeStep?.id}
                            currentActiveStep={playStage[tabIndex]}
                            disabled={disableButton}
                            changeSetUpStepHandler={changeSetUpStepHandler}
                          />
                          {pricing ? <PlayPriceCard image={image} price={pricing} /> : null}
                        </div>
                        <div className="col-span-12 md:col-span-6 hidden md:block lg:hidden">
                          <PlayStepsPanel
                            steps={steps}
                            setUpStepId={activeStep?.id}
                            currentActiveStep={playStage[tabIndex]}
                            disabled={disableButton}
                            changeSetUpStepHandler={changeSetUpStepHandler}
                          />
                        </div>
                        <div className="col-span-12 md:col-span-6  hidden md:block lg:hidden">
                          {pricing ? <PlayPriceCard image={image} price={pricing} /> : null}
                        </div>
                        <div
                          id="play-price-card-wrapper"
                          className="col-span-12 md:col-span-6 block md:hidden lg:hidden mb-10"
                        >
                          {pricing ? <PlayPriceCard image={image} price={pricing} /> : null}
                        </div>
                        <div className="col-span-12 md:col-span-6 block md:hidden lg:hidden">
                          <PlayStepsPanel
                            steps={steps}
                            setUpStepId={activeStep?.id}
                            currentActiveStep={playStage[tabIndex]}
                            disabled={disableButton}
                            changeSetUpStepHandler={changeSetUpStepHandler}
                          />
                        </div>
                      </>
                    )}
                  </>
                ) : null}
                <div
                  id="play-steps-wrapper"
                  className={`${
                    tabHasSteps
                      ? 'col-span-12 lg:col-span-8 mdl:col-span-8 setupDetail order-3'
                      : 'col-span-12'
                  }`}
                >
                  <StepsLargeHeading> {activeStep?.title} </StepsLargeHeading>
                  {activeStep?.stepData?.map((step: any, idx) => {
                    const stepType = step?.stepType
                    const showCollapseable =
                      stepType === PLAY_CARD_BODY_DATA.HTML || stepType === PLAY_CARDS.COLLAPSEABLE
                    const authStepTypes = ['authentication', 'connection', 'input', 'upload']
                    const showAuthenticationContainer = authStepTypes.includes(stepType)

                    return (
                      <div
                        key={`play-question-wrapper-${idx + 1}`}
                        id={`play-question-wrapper-${idx + 1}`}
                        className="mb-10"
                      >
                        {stepType === 'question' &&
                          step?.stepBody?.map((body, idx) => {
                            return body.optionType === 'button' ? (
                              <PlayQuestion
                                key={`play-question-${idx + 1}`}
                                id={`play-question-${idx + 1}`}
                                hideButton
                                body={body}
                                height={'h-full'}
                                moveNext={() => moveNext(idx)}
                                playStage={playStage}
                                disablePlay={
                                  supportedPlayIds.includes(id) ? isPlayInReview : disableButton
                                }
                              />
                            ) : null
                          })}
                        {showCollapseable && (
                          <Collapseable data={step} heading={activeStep.stepTitle} index={idx}>
                            {step?.stepBody?.map((body, bodyIndex) => {
                              return (
                                <div key={`${bodyIndex}${body}`}>
                                  {step.stepType === PLAY_CARD_BODY_DATA.HTML && (
                                    <div>
                                      <div dangerouslySetInnerHTML={createMarkup(body.content)} />
                                    </div>
                                  )}
                                  {/* This component has broken props. */}

                                  {body.type === PLAY_CARD_BODY_DATA.QUESTION && (
                                    <AssessmentQuestion
                                      userId={userId}
                                      onSubmit={() => {}}
                                      uploadedFile={''}
                                      assessmentType={body?.assessmentType}
                                      activeQuestion={body}
                                      setActiveQuestion={() => {}}
                                      uploadFileAction={() => {}}
                                      assessmentResponse={assessmentResponse}
                                      saveAssessmentResponseAction={saveAssessmentResponseAction}
                                      playQuestion={true}
                                      isPlay={true}
                                      disable={
                                        supportedPlayIds.includes(id)
                                          ? isPlayInReview
                                          : disableButton
                                      }
                                      playData={{
                                        options: body.options,
                                        id: body?.id,
                                        index: idx,
                                      }}
                                      savePlayData={savePlayData}
                                      isSupportedPlays={
                                        supportedPlayIds.includes(id) ? true : false
                                      }
                                      selectedOptions={
                                        (playStage[tabIndex].steps[setupActiveStepIndex]
                                          ?.stepData &&
                                          playStage[tabIndex].steps[setupActiveStepIndex]?.stepData[
                                            idx
                                          ]?.value) ||
                                        []
                                      }
                                    />
                                  )}
                                </div>
                              )
                            })}
                          </Collapseable>
                        )}
                        {stepType === PLAY.CALENDAR_MEETING && (
                          <PlayScheduleMeetingContainer
                            meta={meta}
                            data={step}
                            playId={id}
                            user={currentUser}
                            tabIndex={tabIndex}
                            playData={playData}
                            playStage={playStage}
                            isScheduled={isScheduled}
                            isPlayCompleted={isPlayCompleted}
                            moveNext={moveNext}
                            setupActiveStepIndex={setupActiveStepIndex}
                            updatePlayStageAction={updatePlayStageAction}
                            activeStepDataIndex={idx}
                            disabled={
                              supportedPlayIds.includes(id) ? isPlayInReview : disableButton
                            }
                          />
                        )}
                        {showAuthenticationContainer && (
                          <PlaysAuthenticationContainer
                            data={step}
                            oAuthUrl={oAuthUrl}
                            moveNext={moveNext}
                            playStage={playStage}
                            getErrors={getErrors}
                            isConnected={isConnected}
                            setActiveConnectingTool={setActiveConnectingTool}
                            handleCloseAuth={() => {}}
                            playData={playData}
                            user={currentUser}
                            uploadedFile={uploadedFile}
                            playValue={playValue}
                            isPlayCompleted={disableButton}
                            uploadFileAction={uploadFileAction}
                            uploadFileErrors={uploadFileErrors}
                            getOAuthUrlAction={getOAuthUrlAction}
                            isPlayDataSaving={isPlayDataSaving}
                            playId={id}
                            tabIndex={tabIndex}
                            stepIndex={setupActiveStepIndex}
                            stepDataIndex={idx}
                          />
                        )}
                        {stepType === PLAY.SUGGESTIONS && (
                          <OptionalPlays title={step?.title} optionalplays={step?.optionalplays} />
                        )}
                        {stepType === PLAY.MOVE_NEXT_BUTTON && (
                          <div className="w-full flex justify-center">
                            <Button
                              variant="primary"
                              label={step?.stepHeading?.title}
                              onClick={() => moveNext(idx)}
                              testId="button"
                              type="button"
                              disabled={
                                !supportedPlayIds.includes(id)
                                  ? checkDisabled()
                                  : isPlayInReview
                                  ? isPlayInReview
                                  : playData.playTabs[tabIndex]?.tabData.steps[setupActiveStepIndex]
                                      .stepData[idx]?.meta?.isButtonDisabled &&
                                    !isValueExist(
                                      playStage,
                                      tabIndex,
                                      setupActiveStepIndex,
                                      idx - 1
                                    )
                              }
                            />
                          </div>
                        )}
                        {stepType === PLAY.COMPLETE_BUTTON && (
                          <div className="w-full flex justify-center">
                            <Button
                              variant="primary"
                              // label={step.stepHeading.title}
                              label={`Return to ${
                                redirectPath === PathNames.Dashboard
                                  ? capitalize(PathNames.Dashboard)
                                  : capitalize(PathNames.Playbooks)
                              } `}
                              onClick={() => {
                                moveNext(idx)
                                disableButton && navigateTo(ROLES.BUSINESS_OWNER, redirectPath)
                              }}
                              testId="button"
                            />
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default PlayView
